import { Navigate, Route, Routes } from "react-router-dom"
import Login from "../Auth/Login"

const UnAuthRoutes = () => {
    return <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/" />} />
    </Routes>
}

export default UnAuthRoutes;